import { loadScript } from './utils'

class TealiumUTag {
  constructor () {
    window.utag_cfg_ovrd = { noview : true }
    window.utag_data = {}
  }

  public init ({ account, profile, environment }) {
    return loadScript(`https://tags.tiqcdn.com/utag/${account}/${profile}/${environment}/utag.js`)
  }

  private track (type, payload) {
    if (!window.utag) {
      console.error('Utag.js is not initialized')
      return
    }
    window.utag.track(type, payload)
  }

  public view = (payload: unknown) => this.track('view', payload)

  public link = (payload: unknown) => this.track('link', payload)
}

export default TealiumUTag
